import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, ProductContextModel, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Button from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    onClick?: React.EventHandler<React.MouseEvent>;
    product?: CartLineModel | ProductContextModel | OrderLineModel;
    productInfoPath: any;
}
type ViewButtonProps = OwnProps;
type Props = { 
        position?: string,
        productInfo?: any;
    } & HasProductContext;

export interface ViewProductButtonStyles {
    outerBtnStyleWrapper?: InjectableCss;
    innerBtnStyleLeftWrapper?: InjectableCss;
    innerBtnStyleRightWrapper?: InjectableCss;
}

export const viewProductButtonStyles: ViewProductButtonStyles = {
    outerBtnStyleWrapper: {
        css: css`
            display: inline;
            width: 100%;
        `,
    },
    innerBtnStyleRightWrapper: {
        css: css`
            display: inline;
            text-align: right;
            float: right;
            margin: 10px;
        `,
    },
    innerBtnStyleLeftWrapper: {
        css: css`
            display: inline;
            text-align: right;
            float: left;
            margin: 10px;
        `,
    }
};

const styles = viewProductButtonStyles;

const ButtonWithLink = ({
    product,
    productInfoPath,
    onClick
}: ViewButtonProps) => {
    let productDetailPath = product ? "product" in product ? product.productInfo.productDetailPath : product.productUri: "";
    if(productInfoPath) {
        productDetailPath = productInfoPath.productDetailPath ? productInfoPath.productDetailPath :""
    }

    return (
        <Link
            href={productDetailPath}
            alt="See product details"
            onClick={onClick}
            data-test-selector="productLink"
        >
            <Button variant="secondary">
                {translate("View Product")}
            </Button>
        </Link>
    )
};

const ViewProductButton = ({
    productContext,
    position,
    productInfo
}: Props) => {
    const { product } = productContext;

    if (!product) {
        return null;
    }

    return (
        <StyledWrapper {...styles.outerBtnStyleWrapper}>
            {
                position === "left" ? <StyledWrapper {...styles.innerBtnStyleLeftWrapper}>
                    <ButtonWithLink product={productContext} productInfoPath={productInfo}/>
                </StyledWrapper>: <StyledWrapper {...styles.innerBtnStyleRightWrapper}>
                    <ButtonWithLink product={productContext} productInfoPath={productInfo}/>
                </StyledWrapper>
            }
        </StyledWrapper>
    );
};

export default withProductContext(ViewProductButton);
